import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from "@mui/material";
import { EditAccountDialogType } from "../actions/data";
import { DialogContentContainer, DialogContentItem } from "./styles";
import { AccountType } from "../../../constants/securspace-constants";

const EditAccountTypeDialog = (props: EditAccountDialogType) => {

  const {open, onClose, account, onEditTypeAction} = props;
  
  const title = 'Change Account Type';
  const actionMessage = `Change type to: ${account?.userType === AccountType.BUYER ? 'SUPPLIER' : 'BUYER'}`;
  const warningMessage = 'Are you sure you want to change the account type?';

  return <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentContainer>
        <DialogContentItem>
          <Typography>
            {actionMessage}
          </Typography>
        </DialogContentItem>
        <DialogContentItem>
          <Typography>
            Account: {account?.id}
          </Typography>
          <Typography>
            Company: {account?.companyName}
          </Typography>
        </DialogContentItem>
        <DialogContentItem>
            <Typography>
              {warningMessage}
            </Typography>
        </DialogContentItem>
      </DialogContentContainer>
    </DialogContent>
    <DialogActions>
      { account?.id &&
        <Button variant="contained" color='primary' onClick={() => onEditTypeAction(account)}>Save Changes</Button>
      }
      <Button variant='outlined' onClick={onClose}>Close</Button>
      </DialogActions>
  </Dialog>
}

export default EditAccountTypeDialog;